import {
  Box,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useMemo, useState } from "react";

import type { LinkedBroadcast } from "@/api/broadcastV2Audiences";

import { TableHeaderWrapper } from "@/components/DataTable";
import {
  StyledTable,
  StyledTableContainer,
  TablePaper,
} from "@/components/DataTable.styles";
import { ArrowDownwardIcon, ArrowUpwardIcon } from "@/icons";

export function LinkedBroadcastsModalTable({
  broadcasts,
}: {
  broadcasts: LinkedBroadcast[];
}) {
  const [sortDirection, setSortDirection] = useState<"asc" | "desc">("asc");
  const sortedBroadcasts = useMemo(() => {
    const copy = [...broadcasts];
    copy.sort((a, b) => {
      const cmp = a.name.localeCompare(b.name, undefined, {
        sensitivity: "base",
      });
      return sortDirection === "asc" ? cmp : -cmp;
    });
    return copy;
  }, [broadcasts, sortDirection]);

  const handleSort = () => {
    setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"));
  };

  return (
    <TablePaper sx={{ border: "none" }}>
      <StyledTableContainer sx={{ maxHeight: 220, overflow: "auto" }}>
        <StyledTable size="small" aria-label="Linked broadcasts">
          <TableHead>
            <TableRow>
              <TableHeaderWrapper isSortable onClick={handleSort}>
                <Box
                  component="span"
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  Broadcast name
                  {sortDirection === "asc" ? (
                    <ArrowUpwardIcon sx={{ fontSize: 16 }} />
                  ) : (
                    <ArrowDownwardIcon sx={{ fontSize: 16 }} />
                  )}
                </Box>
              </TableHeaderWrapper>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedBroadcasts.map((broadcast, index) => (
              <TableRow key={broadcast.id}>
                <TableCell
                  sx={(theme) => ({
                    py: 2,
                    px: 2,
                    border: "none",
                    backgroundColor:
                      index % 2 === 0
                        ? theme.palette.grey[50]
                        : theme.palette.common.white,
                  })}
                >
                  <Typography variant="body2">{broadcast.name}</Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </StyledTable>
      </StyledTableContainer>
    </TablePaper>
  );
}
